import React from 'react';

import { feltMetaGroupStyle } from './feltTypography';
import TableDetails from './TableDetails';
import TableGameInfo from './TableGameInfo';

/**
 * EN-10520 — the felt's under-board text, as ONE component level.
 *
 * Table No / Hand No used to be parked in a corner of the felt by Game.tsx
 * (bottom-right single-table, top-left in a grid cell) while the blinds line was
 * rendered by the table itself. Two owners, two anchors, two type treatments,
 * and no way to keep them evenly spaced.
 *
 * They are siblings in one flex column now — board cards above, table/hand
 * number, then the blinds / game-type line — sharing `feltTypography`'s scale
 * and one `gap`. Both orientations mount this in the same slot, so the reading
 * order is identical portrait and landscape.
 */
export const FeltMeta = () => (
  <div style={feltMetaGroupStyle} data-testid='felt-meta'>
    <TableGameInfo />
    <TableDetails />
  </div>
);

export default FeltMeta;
